import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { distributionData, onboard, PrinterSettings } from '../../interface/distributions/distributions';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { localStorageVar } from 'src/app/modules/admin/pages/localstoragevar';
// import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DistributionsService {
  public token: BehaviorSubject<string | null>;
  public distribution: BehaviorSubject<any | null>;
  public accountLevel: BehaviorSubject<any | null>;
  printerSettings: PrinterSettings | null = null;

  constructor(private _httpauth: HttpService) {
    this.distribution = new BehaviorSubject(JSON.parse(localStorage.getItem(localStorageVar.distribution)) || null);
    this.accountLevel = new BehaviorSubject(localStorage.getItem(localStorageVar.accountLevel || null))
  }


  getAllDistributions() {
    return this._httpauth.get('/Distributions');
  }
  getDistributionPrintHeader(): Promise<PrinterSettings> {
    if (this.printerSettings != null) return Promise.resolve(this.printerSettings);
    return firstValueFrom(this._httpauth.get('/Distributions/printer-settings'))
      .then(x => { this.printerSettings = x; return x; });
  }
  updateDistributionPrintHeader(data: distributionData): Promise<any> {
    return firstValueFrom(this._httpauth.put('/Distributions/printer-settings', "", data));
  }
  addDistribution(data: onboard): Promise<any> {
    // return this._httpauth.post('/Distributions/onboard',data);
    return firstValueFrom(this._httpauth.post('/Distributions/onboard', data)).then((x) => {
      this.distribution.next(x);
      localStorage.setItem(localStorageVar.distribution, JSON.stringify(x));
      localStorage.setItem(localStorageVar.accountLevel, x.accountLevel)

      return x;
    });
  }
}
